// import '@babel/polyfill';
// import 'mutationobserver-shim';
import 'babel-polyfill';

import Vue from 'vue';
import Vuex from 'vuex';
import VueAxios from 'vue-axios';
import axios from 'axios';
import BootstrapVue from 'bootstrap-vue';
import VueMoment from 'vue-moment';
import lodash from 'lodash';
import VueLodash from 'vue-lodash/dist/vue-lodash.min';
import VueConfig from 'vue-config';
import Vue2Filters from 'vue2-filters';
import VueChart from 'vue-chart-js';
import moment from 'moment';
import 'moment/locale/it';
import 'moment/locale/en-gb';
import 'chart.js';
import { sync } from 'vuex-router-sync';
import VeeValidate, { Validator } from 'vee-validate';
import ValidateMsgIt from 'vee-validate/dist/locale/it';
import ValidateMsgEn from 'vee-validate/dist/locale/en';
import * as VueGoogleMaps from 'vue2-google-maps';
import VueAnalytics from 'vue-analytics';
import VueI18n from 'vue-i18n';
import Loading from 'vue-loading-overlay';
import VueScrollTo from 'vue-scrollto';

import VueComponents from './plugins/vue-components';
import VueToastr from './plugins/vue-toastr';
import VueSweetAlert from './plugins/vue-swal';
import Utils from './plugins/vue-utils';
import Validators from './plugins/validators';

import 'bootstrap/dist/css/bootstrap.css';
import 'bootstrap-vue/dist/bootstrap-vue.css';
import 'vue-loading-overlay/dist/vue-loading.min.css';
import '@/assets/modules/cosmo.css';
import '@/assets/modules/custom.css';
import '@/assets/vendors/font-icomoon/style.css';

import '@fortawesome/fontawesome-free-webfonts/css/fontawesome.css';
import '@fortawesome/fontawesome-free-webfonts/css/fa-regular.css';
import '@fortawesome/fontawesome-free-webfonts/css/fa-solid.css';
import '@fortawesome/fontawesome-free-webfonts/css/fa-brands.css';

import App from './App';
import router from './router';
import store from './store';
import apiClient from './apiClient';
import authManager from './authManager';
import filters from './filters';

import config from './config';
import it from './locales/it';
import en from './locales/en';

sync(store, router);

Vue.config.productionTip = false;
Vue.config.silent = true;

Vue.use(Vuex);
Vue.use(VueAxios, axios);
Vue.use(BootstrapVue);
Vue.use(VueLodash, lodash);
Vue.use(VueToastr);
Vue.use(Vue2Filters);
Vue.use(VueSweetAlert);
Vue.use(VueChart);
Vue.use(Utils);
Vue.use(VueComponents);
Vue.use(Loading);
Vue.use(VueScrollTo);

_.forOwn(filters, (value, key) => {
  Vue.filter(key, value);
});

moment.locale('it');

Vue.use(VueMoment, { moment });
Vue.use(VueConfig, config);
Vue.use(apiClient, {
  baseURL: `${config.API_BASE_URL}/api/v1/`,
});


Validator.localize('it', ValidateMsgIt);

Vue.use(VeeValidate, {
  locale: 'it',
  fieldsBagName: 'b-form-input',
  classNames: {
    touched: 'has-focused',
    untouched: 'untouched',
    valid: 'has-success',
    invalid: 'has-danger',
    pristine: '',
    dirty: 'has-warning',
  },

});

Validators.register(VeeValidate);

Vue.use(VueAnalytics, {
  id: 'UA-88845439-5',
  router,
});

Vue.use(VueGoogleMaps, {
  load: {
    key: 'AIzaSyC5Hze25LKLcIhEpkkoVZtxutj4cJu_xfY',
    libraries: 'places',
  },
});

Vue.use(VueI18n);

const i18n = new VueI18n({
  locale: 'it',
  messages: { it, en },
  silentTranslationWarn: true,
});

/* eslint-disable no-new */
new Vue({
  el: '#app',
  http: axios,
  auth: authManager,
  router,
  store,
  i18n,
  template: '<App/>',
  components: { App },
});



// WEBPACK FOOTER //
// ./src/main.js